export const LOGIN_TAG_NAME = 'tm-bo-login';
